import {useCookies} from "react-cookie";

export const useLogin = () => {
  const [cookies] = useCookies(["user_session"])

  return cookies.user_session !== undefined && cookies.user_session.length > 0
}